import { useState, useEffect } from 'react';
import {
    BrowserRouter as Router,
    Route,
    Switch
} from "react-router-dom";
import { connect } from "react-redux";
import { useIdleTimer } from 'react-idle-timer'

import {
    getProfile,
    logout
} from './actions';

import Main from './components/sections/Main';
import Footer from './components/sections/Footer';
import Loader from './components/elements/Loaders';
import PasswordReset from './components/sections/Main/PasswordReset';
import PasswordRecovery from './components/sections/Main/PasswordRecovery';

const mapStateToProps = state => ({
    auth: state.user.email
});


const mapDispatchToProps = (dispatch) => ({
    getProfile: () => dispatch(getProfile()),
    logout: () => dispatch(logout())
});

const _RoutedApp = ({ getProfile, auth, logout }) => {
    const [firstLoad, setFirstLoad] = useState(false);

    const handleOnIdle = () => {
        if(auth) {
            logout();
        }
    }
    
    useIdleTimer({
        timeout: 1000 * 60 * 15,
        onIdle: handleOnIdle,
        debounce: 500
    })
    
    useEffect(() => {
        if (!firstLoad) {
            getProfile();
            setTimeout(() => { setFirstLoad(true); }, 500);
        };
        return () => setFirstLoad(true);
    }, [firstLoad, getProfile, setFirstLoad]);

    return (
        firstLoad
            ?
            <Router>
                <Switch>
                <Route path={["/pz-recovery", "/Goldprofile/recupera_pwd_rn.jsp", "/Goldprofile/recupera_pwd_rn_en.jsp"]} exact>
                    <PasswordRecovery isWebViewEmbed={true} />
                </Route>
                <Route path="/pz-reset" exact>
                    <PasswordReset isWebViewEmbed={true} />
                </Route>
                <Route>
                    <Main />
                    <Footer />
                    <Loader />
                </Route>
                </Switch>
            </Router>
            :
            null
    );
};

const RoutedApp = connect(mapStateToProps, mapDispatchToProps)(_RoutedApp);

export default RoutedApp;